import styled from "@emotion/styled/macro";
import {ThemeColors} from "../../layout/GlobalLayout";
import React from "react";
import {getOptionNameMap} from "./GetOptionNameMap";
import Checkbox from "../../common/checkbox/Checkbox";
import {IOptionItem, IOptionItemAvailableChoice, IOptionItemChoice} from "@bimaire/optionslib";

const ConfiguratorValuesDiv = styled.div`
    ul {
        display: flex;
        flex-direction: column;
        gap: 10px;
        justify-content: center;
        padding: 0;
    }

    li {
        list-style: none;
        display: block;

        > * {
            height: 38px;

        }

        background-color: white;
    }

    h4 {
        /* Elevation */


        font-family: 'Bw Nista Geometric';
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 25px;
        /* identical to box height, or 139% */

        margin: 0;

        /* Dark Platinum */

        color: ${ThemeColors.darkplatinum};

    }
`

interface IConfiguratorValuesProps {
    selection: IOptionItem;
    values: IOptionItemAvailableChoice[];
    selectedChoice: IOptionItemChoice;
    onSelect: (opt: IOptionItemChoice) => void;
}

export const ConfiguratorValues: React.FC<IConfiguratorValuesProps> = (props) => {
    const {values, selection, selectedChoice, onSelect} = props;
    const optNameMap = getOptionNameMap(selection.id, values);

    /*useEffect(() => {
        console.log(selectedChoice.choice.items[1].item.name);
        if (selectedChoice.choice.items[1].item.name === "Please Select" || selectedChoice.choice.items[1].item.name === "Not Selected") {
            console.log('overriding choice to ' + values[1].items[1].item.name);
            onSelect({choice: values[1], quantity: 1, price:null});
        }

    }, [selectedChoice.choice.items[1].item.name])*/
    let optvalname = values[0].items[0].item.name;
    if (optvalname === "Whole House Design Upgrade Package") {
        optvalname = "Interior Design Package";
    }
    return <ConfiguratorValuesDiv>
        <h4>{optvalname} </h4>


        <ul>
            {values./*filter(val => val.items[1].item.name !== "Please Select" && val.items[1].item.name !== "Not Selected").*/map(val =>
                <li title={val.items.slice(1).map(itm => itm.item.id).join('_')}>
                    <Checkbox checked={selectedChoice?.choice === val}
                              onValueChanged={() => onSelect({choice: val, quantity: 1, price: null})}>
                        {optNameMap.get(val)!.name}
                    </Checkbox>
                </li>)}
        </ul>
    </ConfiguratorValuesDiv>
}